import React, { useState } from 'react';
import DayJSUtils from '@date-io/dayjs';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import './styles.scss';
import { noop } from '../propTypes';
import FormInput from '../FormInput';

function CustomDatePicker({ handleDateChange, title, bootstrapIcon }) {
    // use State to update the date when the onChange event is dispatched
    const [selected, setSelected] = useState(null);
    return (
        <FormInput title={title} bootstrapIcon={bootstrapIcon}>
            <MuiPickersUtilsProvider utils={DayJSUtils}>
                <DatePicker
                    value={selected}
                    onChange={(date) => {
                        handleDateChange(date);
                        setSelected(date);
                    }}
                    format="DD/MM/YYYY"
                    placeholder="DD/MM/YYYY"
                    clearable={true}
                />
            </MuiPickersUtilsProvider>
        </FormInput>
    );
}

CustomDatePicker.propTypes = {
    handleDateChange: PropTypes.func,
    title: PropTypes.string,
    bootstrapIcon: PropTypes.string,
};

CustomDatePicker.defaultProps = {
    handleDateChange: noop,
    title: 'Challenge',
    bootstrapIcon: 'icon-flag',
};

export default CustomDatePicker;
